!function(root, app) {
    app.events = app.events || {};
    app.events.base = {
        isVideoPlaying: false,
        isLightboxOpen: false,
        unlocksRetrieved: {},
        eventId: null,
        platformId: null,
        init: function() {
            this.defineProps();
            this.setupOverviewVideo();
            this.setupFadeIn();
            this.setupUnlocks();
            root.overwatch.EventMapCarousel.init();
            this.setupMapsAnalytics();
            root.overwatch.slideout.init();
            this.markOwnedUnlocks();
        },
        defineProps: function() {
            //global elements
            this.$body = $(document.body);
            this.$window = $(window);
            this.$lightbox = $('.lightbox');
            //page containers and elements
            this.$eventOverviewContainer = $('[data-js="event-overview"]');
            this.$videoCloseButton = $('[data-video-close="true"]');
            this.$overviewVideoWrapper = $('[data-js="video-wrapper"]');
            this.overviewVideoYoutubeId = $("#event-video-player").data("video-id");
            this.frameHTML = document.getElementById('unlock-frame-template').innerHTML;
            this.iconHTML = $("#event-icon-template").html() || "";
            this.loader = $('[data-js="unlocks-loader"]');
            if(this.eventId) {
                this.unlocksRetrieved[this.eventId] = true;
            }
        },
        setupOverviewVideo: function() {
            var self = this;
            var attachPlayButtonHandler = function() {
                $('[data-js="event-overview-play"]').on("click", function(e) {
                    if (overwatch.util.isSizeAtLeast("md")) {
                        e.preventDefault();
                        self.openVideo();
                    }
                });
            };
            window.onYouTubeIframeAPIReady = function() {
                //Create the event youtube video player
                self.ytVideoPlayer = new YT.Player('event-video-player', {
                    height: "100%",
                    width: "100%",
                    videoId: self.overviewVideoYoutubeId,
                    playerVars: { rel: 0, modestbranding: 1, autohide: 1, color: "white", playsinline: 1 },
                    events: {
                        'onStateChange': self.handleVideoStateChange.bind(self),
                        'onReady': attachPlayButtonHandler
                    }
                });
            };
            this.$videoCloseButton.on("click", function(e) {
                self.closeVideo();
            });
            self.$window.on("scroll", _.throttle(function() {
                self.popoutVideo();
            }, 100));
            this.handleVideoLightboxConflicts();

            this.$body.on('event.video-open', function() {
                self.$eventOverviewContainer.addClass("is-playing");
                self.$body.addClass("nav-transparent");
            });
            this.$body.on('event.video-close', function() {
                self.$eventOverviewContainer.removeClass("is-playing");
                self.$body.removeClass("nav-transparent");
            });
        },
        handleVideoStateChange: function(event) {
            //Restart and hide the video when it ends.
            if (event.data == 0) {
                this.closeVideo();
                this.ytVideoPlayer.seekTo(0);
                this.isVideoPlaying = false;
            } else if (event.data == 1) {
                this.isVideoPlaying = !this.isLightboxOpen;
            } else if (event.data == 2) {
                this.isVideoPlaying = this.isLightboxOpen;
            }
        },
        popoutVideo: function() {
            //Should the video be popped out?
            if (overwatch.util.isSizeAtLeast("md")) {
                this.isScrollPointPastOverview = app.util.getNormalizedWindowScrollTop(this.$window) > (this.$eventOverviewContainer.height() - 100);
                if (this.isScrollPointPastOverview) {
                    this.$overviewVideoWrapper.addClass("is-popout");
                } else {
                    this.$overviewVideoWrapper.removeClass("is-popout");
                }
            }
        },
        handleVideoLightboxConflicts: function() {
            //Pause the video when the user views a lightbox
            this.$lightbox.on('show', function() {
                if (overwatch.util.isSizeAtLeast("md") && this.isVideoPlaying) {
                    this.ytVideoPlayer.pauseVideo();
                }
                this.isLightboxOpen = true;
            });
            this.$lightbox.on('hide', function() {
                if (overwatch.util.isSizeAtLeast("md") && this.isVideoPlaying) {
                    this.ytVideoPlayer.playVideo();
                }
                this.isLightboxOpen = false;
            });
        },
        openVideo: function() {
            this.ytVideoPlayer.playVideo();
            this.$overviewVideoWrapper.show();
            this.$videoCloseButton.show();

            this.$body.trigger('event.video-open', {
                videoId: this.overviewVideoYoutubeId
            });
        },
        closeVideo: function() {
            this.ytVideoPlayer.pauseVideo();
            this.$overviewVideoWrapper.hide();
            this.$videoCloseButton.hide();

            this.$body.trigger('event.video-close', {
                videoId: this.overviewVideoYoutubeId
            });
        },
        setupFadeIn: function() {
            $(".media-card").each(function() {
                $(this).attr("data-fadein", "true");
            });
            app.Fadein.init();
        },
        setupUnlocks: function() {
            var _this = this;
            var platformButtons = $('[data-js="unlock-platform-swap"]');
            platformButtons.on("click", function(event) {
                var $this = $(this);
                var id = $this.data('platformId');
                _this.platformId = id;
                platformButtons.removeClass("is-active");
                $this.addClass("is-active");
                _this.markOwnedUnlocks();
            });
            this.setupUnlockGallery(this.unlockMedia);
        },
        setupUnlockGallery: function(media) {
            var data = {};
            data[this.eventId+':skins'] = media.skins;
            data[this.eventId + ':highlightIntros'] = media.highlightIntros;
            data[this.eventId + ':emotes'] = media.emotes;
            app.media.setupGallery(data);
        },
        preselectUnlocks: function () {
            var preselectedEvent = window.localStorage.getItem("selectedEvent");
            if (preselectedEvent && this.eventId !== preselectedEvent) {
                this.eventId = preselectedEvent;
                this.updateUnlocksTab(this.eventId);
            }
        },
        updateUnlocksTab: function (eventId) {
            this.eventId = eventId;
            window.localStorage.setItem("selectedEvent", eventId);
            this.updateUnlocks();
        },
        updateUnlocks: function () {
            var eventId = this.eventId;
            if (!eventId) { return; }
            if (this.unlocksRetrieved[eventId]) {
                $('[data-js="unlocks"]').hide();
                $("#event-unlocks--"+eventId).show();
            } else {
                this.getUnlocksByEvent();
            }
            this.updateEventIcon();
        },
        updateEventIcon: function() {
            var eventId = this.eventId;
            $('[data-js="event-icon"]').replaceWith(this.iconHTML.replace("{{eventId}}", eventId));
        },
        getUnlocksByEvent: function() {
            var _this = this;
            var eventId = this.eventId;
            this.loader.addClass("is-active");
            $.get("/events/unlocks/" + eventId, function(data) {
                $('[data-js="unlocks"]').hide();
                $("#event-unlocks--"+eventId).html(data.unlockHtml).show();
                app.media.addGallery($("#event-unlocks--"+eventId));
                _this.setupUnlockGallery(data.unlocks);
                _this.unlocksRetrieved[eventId] = true;
            }).always(function() {
                _this.loader.removeClass("is-active");
                _this.markOwnedUnlocks();
            });
        },
        markOwnedUnlocks: function() {
            var _this = this;
            var platformId = this.platformId;
            var url = platformId ? '/user/unlocks/' + platformId : '/user/unlocks/';
            if(app.helpers.userLoggedIn()) {
                this.loader.addClass("is-active");
                $.get(url, function(userUnlocks) {
                    $('[data-media-id]').each(function() {
                        var id = $(this).data('mediaId');
                        var owned = (userUnlocks.indexOf(id) !== -1);
                        _this.updateUnlockFrame(id, owned);
                    });
                }).always(function() {
                    _this.loader.removeClass("is-active");
                });
            }
        },
        updateUnlockFrame: function(id, owned) {
            var $unlockItem = $("#" + id);
            if (owned) {
                $unlockItem.addClass('frame');
            } else {
                $unlockItem.removeClass('frame');
            }
        },
        setupMapsAnalytics: function() {
            var maps = $('[data-js="event-map"]');
            maps.each(function() {
                $(this).one('transitionend', function() {
                    var eventName = $(this).data('eventAnalytics');
                    if (eventName) {
                        dataLayer.push({
                            event: 'dataEventMap',
                            dataEventName: eventName
                        });
                    }
                });
            });
        }
    };
}(this, this.app);
